import {Message, Notification} from "element-ui"
import axios from "axios"
/**
 * 下载媒体文件
 * @param downUrl 文件url
 * @param fileName 文件名（自定义）
 * @param fileType 文件类型（如：mp3 默认为mp3）
 * @param callback 下载失败后的回调函数
 */
export const download = (downUrl, fileName, fileType, callback) => {
    Notification.info('正在尝试下载，请稍后')
    axios.get(downUrl + '?response-content-type=application/octet-stream', {
        responseType: 'blob',
        headers: {'content-type': 'audio/mpeg'}
    }).then((res) => {
        Notification.success('下载成功，请稍后')
        // 设置blob请求头
        // let blobType = 'application/force-download'
        // 创建blob 设置blob文件类型 data 设置为后端返回的文件(例如mp3,jpeg) type:这里设置后端返回的类型 为 mp3
        let blob = new Blob([res.data], {type: res.data.type})
        // 创建A标签
        let downa = document.createElement('a')
        // 创建下载的链接
        let href = window.URL.createObjectURL(blob)
        // 下载地址
        downa.href = href
        // 下载文件名
        const type = fileType ? fileType : 'mp3'
        downa.download = fileName + '.' + type
        document.body.appendChild(downa)
        downa.click() // 模拟点击A标签
        // 下载完成移除元素
        document.body.removeChild(downa)
        // 释放blob对象
        window.URL.revokeObjectURL(href)
    }).catch((error) => {
        const response = error.response
        if (response) {
            // 说明请求发送成功，有响应  如果存在跨域问题，则请求会被拦截，没有响应
            if (response.status === 404) {
                // 找不到资源，没办法下载
                Message.error('下载失败！找不到资源')
                return
            }
        }
        Message.error('下载失败！' + error + ' 请尝试其他方式')
        // 失败时的回调
        if (callback) {
            callback()
        }
    });
}
